module.exports = __webpack_public_path__ + "static/media/12x12-16.d17e357b.png";